export default __webpack_public_path__ + "static/img_welfare_9-2cfffaacf020c83fdaf8b6fb0af4746e.jpg";